import styled from "@emotion/styled"
import colors from "theme/colors"
import { Container, NewText, TitleWithLine, extractProperty } from "ui"

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 40px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 40px;
  }
`

const StyledContentBlock = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`

const StyledTitleAndText = styled.div`
`

const StyledNewText = styled(NewText)`
  padding: 10px 0px;
`

type Props = {
    data: any
}

function ContentText({ data }: Props) {
    const title = extractProperty(data, "conetntTitle") || extractProperty(data, "subTitle")
    const innerText = extractProperty(data, "innerText")

    return (
        <Container padding={0}>
            <StyledWrapper>
                <StyledContentBlock>
                    <StyledTitleAndText>
                        {title && (
                            <TitleWithLine
                                component={"h2"}
                                largeDesktopFontSize={34}
                                largeDesktopLineHeight="36px"
                                titleFontSize={34}
                                desktopLineHeight={"36px"}
                                mobileTitleFontSize={24}
                                mobileLineHeight={"28px"}
                                desktopFontWeight={500}
                                title={title}
                                titleColor={colors.black}
                            />
                        )}
                        {innerText && (
                            <StyledNewText
                                component={"p"}
                                largeDesktopFontSize={18}
                                largeDesktopLineHeight="20px"
                                desktopFontSize={18}
                                desktopLineHeight={"20px"}
                                desktopFontWeight={400}
                                mobileFontSize={16}
                                mobileLineHeight={"18px"}
                                mobileFontWeight={400}
                                dangerouslySetInnerHTML={{ __html: innerText }}
                            />
                        )}
                    </StyledTitleAndText>
                </StyledContentBlock>
            </StyledWrapper>
        </Container>
    )
}

export default ContentText
